const routes = [{
  path: '/scheme',
  component: () => import('@/views/scheme'),
  name: 'scheme'
}, {
  path: '/inssort',
  component: () => import('@/views/scheme/insSort'),
  name: 'inssort'
}, {
  path: '/quotation',
  component: () => import('@/views/scheme/quotation'),
  name: 'quotation'
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/scheme.js